@if (cistern) {
  <app-card
    style="--spacing: 1rem"
    [class.withAnimation]="withAnimation"
    [class.link]="isClickable"
    [routerLink]="routerLink"
    [queryParams]="queryParams"
  >
    @if (withAnimation) {
      <div class="bg" [ngStyle]="{ 'height.%': percent }">
        <div class="water"></div>
      </div>
    }
    @if (!withAnimation) {
      <div>
        <h3 class="mb-1">
          <app-text-with-icon name="ic_cistern">{{
            cistern.name
          }}</app-text-with-icon>
        </h3>

        @if (deviceFullAt) {
          <small>{{
            "devices.detail.estimatedFullAt" | translate: { date: deviceFullAt }
          }}</small>
        }
      </div>
    }
    <div class="content flex justify-between">
      <p>
        <b>{{ absolut | localizedNumber: "1.0-0" }} l</b><br />
        <small
          >{{ "default.pagination.of" | translate }}
          {{ cistern.literCapacity | localizedNumber: "1.0-0" }} l</small
        >
      </p>

      <p class="large">
        {{ percent / 100 | localizedPercent: "1.0-0" }}
      </p>
    </div>
    @if (withAnimation) {
      <div class="footer">
        <h3>{{ cistern.name }}</h3>
        @if (isClickable) {
          <app-icon name="ic_chevron_right" />
        }
      </div>
    }
  </app-card>
}
